module.exports = __webpack_public_path__ + "img/banner.5cef155d.jpg";